"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var styled_system_1 = require("styled-system");
var flexbox_1 = require("./flexbox");
var buttons = styled_system_1.variant({ key: "buttons" });
exports.Button = styled_1.default(flexbox_1.Flexbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject([" \n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  cursor: pointer;\n  \n  & img {\n    display: block;\n  }\n"], [" \n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  cursor: pointer;\n  \n  & img {\n    display: block;\n  }\n"])), styled_system_1.fontWeight, styled_system_1.borders, styled_system_1.borderColor, styled_system_1.borderRadius, styled_system_1.buttonStyle, buttons, function (p) { return p.theme["Button"]; });
exports.Button.defaultProps = {
    as: "button",
    fontSize: "inherit",
    fontWeight: "bold",
    m: 0,
    px: 3,
    py: 2,
    border: 0,
    borderRadius: 4,
    alignItems: "center"
};
exports.Button.displayName = "button";
var templateObject_1;
